import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import Dates from "../../../classes/dates";
import moment from "moment";
import RaisedButton from "material-ui/RaisedButton";
import Button from "react-bootstrap/lib/Button";
import csvConvert from "../../../classes/csvConvert";
import toastr from "toastr";

let dateObject = new Dates();
function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  if (row.newEntry)
    return 'blue';
  else return '';
}
class RosterTable extends React.Component {

  constructor() {
    super();
    this.state = {
      dateRange: [],
      roster: [[]],
      dirty: false,
      downloadLink: "a",
      csv: null,
      edit: false,
      previous: false
    };
    this.returnButton = this.returnButton.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
  }

  returnButton(cell, row, rowIdx, colIdx) {

  }

  componentDidMount() {

  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let tableData = csvContent.convertArrayOfObjectsToCSV({data: this.state.roster});
    console.log(tableData);
    let filename = moment(this.props.dates.startDate).format('YYYY-MM-DD') + "to" + moment(this.props.dates.endDate).format('YYYY-MM-DD');

    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    tableData = encodeURI(tableData);
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: tableData});
      resolve(true);
    });
    getCsv.then((resposne)=> {
      this.download.click();
    })
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  componentWillReceiveProps(props) {
    if (props.dates.startDate != null && props.dates.endDate != null) {

      let dateRange = dateObject.getDates(props.dates.startDate, props.dates.endDate);

      let row = new Object();
      props.teamRoster.map((node)=> {
        row[node.empId] = false;
      })
      if (props.previous)
        this.setState({
          dateRange: dateRange,
          roster: props.teamRoster,
          dirtyRows: row,
          dirty: true,
          edit: false,
          previous: true
        })
      else
        this.setState({
          dateRange: dateRange,
          roster: props.teamRoster,
          dirtyRows: row,
          dirty: false,
          edit: false,
          previous: false
        })


    }
  }

  render() {
    console.log("Here are my props");
    console.log(this.props);
    const options = {

      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };

    return (
      <div>

        <div className="col-md-12">
          <a href={this.state.csv}
             download={"Roster" + moment(this.props.dates.startDate).format('YYYY-MM-DD') + "to" + moment(this.props.dates.endDate).format('YYYY-MM-DD')}
             ref={(input) => {
               this.download = input;
             }}/>

          <div className="col-md-10">
            {!this.state.edit && !this.state.previous ? <Button
              className="btn-default"
              bsSize="medium"
              onClick={()=> {
                this.setState({edit: true});
              }}
              style={{width: '100px'}}
            >Edit</Button>
              : <div style={{display: 'inline'}}>

              <Button
                disabled={!this.state.dirty}
                style={{}}
                onClick={()=> {
                  let finalRequestObject = new Array();
                  this.state.roster.map((node)=> {
                    if (this.state.dirtyRows[node.empId]) {
                      let requestObject = new Object();
                      requestObject.empId = node.empId;
                      requestObject.startDate = moment(this.props.dates.startDate).format('YYYY-MM-DD');
                      requestObject.endDate = moment(this.props.dates.endDate).format('YYYY-MM-DD');
                      let policy = "";
                      Object.keys(node).map((date)=> {
                        if (date != 'empId' && date != 'name')
                          policy = policy + node[date];
                      });
                      requestObject.policy = policy;
                      finalRequestObject.push(requestObject);
                    }
                  });
                  console.log(JSON.stringify(finalRequestObject));
                  this.setState({dirty: false})
                  this.props.submit(finalRequestObject);
                }}>Save</Button>

              <Button
                className="btn-default"
                bsSize="medium"
                disabled={this.state.previous}
                onClick={this.props.usePrevious}
                style={{width: '100px', marginLeft: '20px'}}
              >Use Previous</Button>

              <Button
                className="btn-default"
                bsSize="medium"
                onClick={()=> {
                  if (this.state.dirty)
                    this.props.refresh();
                  this.setState({edit: false})
                }
                }
                style={{width: '100px', marginLeft: '20px'}}
              >Cancel</Button>
            </div>}</div>
          <div className="col-md-2">
            <Button
              onClick={this.downloadCsv}
              style={{backgroundColor: 'rgb(92, 184, 92)', marginLeft: '50px'}}
            ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>
          </div>
        </div>

        <div className="col-md-12" style={{padding: 0, margin: 0}}>
          <BootstrapTable
            options={options}
            maxHeight={500}
            containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
            headerStyle={{
              borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
              , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
            }}
            tableStyle={{marginBottom: '5%', borderStyle: 'solid'}}


            data={this.state.roster}>
            <TableHeaderColumn dataSort={true}
                               exportCSV={true}
                               filter={{type: 'TextFilter', placeholder: 'Id'}}
                               columnClassName="rowX"
                               isKey={true} width={80}
                               dataField="empId">Emp Id</TableHeaderColumn>

            <TableHeaderColumn dataSort={true}
                               exportCSV={true}
                               filter={{type: 'TextFilter', placeholder: 'Name'}}
                               columnClassName="rowX"
                               width={120}
                               dataField="name">Name</TableHeaderColumn>

            {this.state.dateRange.map((node, id)=> {

              return <TableHeaderColumn
                columnClassName={columnClassNameFormat}
                dataField={moment(node).format('YYYY-MM-DD')}
                width={140}
                dataFormat={(cell, row, extraData, rowIdx)=> {


                  if (cell == 'L')
                    return <RaisedButton

                      label="Leave" primary={false} secondary={false} disabled={true}/>

                  return <RaisedButton
                    primary={cell == 'W'}
                    secondary={cell == 'N'}


                    onClick={()=> {
                      if (this.state.edit) {
                        if (!this.state.dirty)
                          this.setState({dirty: true});

                        let roster = this.state.roster;
                        let rosterRow = roster.filter((node)=> {
                          if (node.empId == row.empId)
                            return true;
                        });
                        let status = rosterRow[0][moment(node).format('YYYY-MM-DD')];
                        if (status == 'W') {
                          let count = 0;
                          console.log(rosterRow[0]);
                          Object.keys(rosterRow[0]).map((date)=> {
                            if (rosterRow[0][date] == 'N')
                              count++;
                          });
                          if (count >= 2) {
                            toastr.error("Only Two Weekly Offs Allowed");
                            return;
                          }
                          console.log(count);
                          rosterRow[0][moment(node).format('YYYY-MM-DD')] = 'N';
                        }
                        else
                          rosterRow[0][moment(node).format('YYYY-MM-DD')] = 'W';
                        roster = roster.map((node)=> {
                          if (node.empId == row.empId)
                            return rosterRow[0];
                          else
                            return node;
                        });
                        let dirtyRows = this.state.dirtyRows;
                        if (!dirtyRows[row.empId])
                          dirtyRows[row.empId] = true;
                        this.setState({roster: roster, dirtyRows: dirtyRows});
                      }
                      else
                        toastr.info("Click on Edit to make changes to Roster")

                    }}
                    label={cell == 'W' ? "Working" : cell == 'N' ? "WO" : cell == 'P' ? 'PH' : 'NA'}
                    type="button"/>
                }}>{node.toDateString().substr(0, 11)}<br/>{this.props.summary[moment(node).format('YYYY-MM-DD')]}
              </TableHeaderColumn>
            })}

          </BootstrapTable></div>
      </div>
    );
  }
}

RosterTable.propTypes = {};

export default RosterTable;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/AttendanceRoster/RosterTable.js
 **/